<template src="./template.html"></template>
<style src="./profile.scss" lang="scss"></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { cloneDeep, find } from 'lodash'

  export default {
    name: 'ProfilePage',
    components: {
      ProfileVariantGuestView: () => import('./variants/ProfileVariantGuestView'),
      ProfileVariantFullView: () => import('./variants/ProfileVariantFullView'),
      ProfileDefaultView: () => import('./variants/ProfileDefaultView'),
    },
    metaInfo() {
      return {
        title: this.$t('meta.profile.title', { name: this.displayUserName(this.user) }),
      }
    },
    computed: {
      ...mapFields('chat', [
        'conversationId',
        'isOpen',
        'selectedPanel',
      ]),
      ...mapState('users', [
        'user',
        'userTopics',
        'userChildren',
      ]),
      ...mapState('auth', { activeUser: 'user' }),
      ...mapState('auth', ['settings']),
      isOwn() {
        return this.activeUser && (
          this.user.id === this.activeUser.user_id
        )
      },
      canEdit() {
        return this.activeUser && find(this.activeUser.permissions, p => [
          'superadmin',
          'users',
        ].indexOf(p) !== -1)
      },
      isAdminUrl() {
        return this.user.admin_url
      },
      canEditUsersProfile() {
        return this.isOwn || this.canEdit || this.isAdminUrl
      },
      religions() {
        return cloneDeep(this.userTopics).shift()
      },
      topics() {
        const topics = cloneDeep(this.userTopics)
        topics.shift()
        return topics
      },
    },
    watch: {
      '$route.params.id'(value) {
        this.getUser(value)
        this.init(value)
      },
    },
    created() {
      this.getUser(this.$route.params.id)
      this.init(this.$route.params.id)
    },
    destroyed() {
      this.clearUser()
    },
    methods: {
      ...mapActions('chat', ['chat']),
      ...mapActions('users', [
        'getUser',
        'clearUser',
        'getPersonalDataTopics',
        'getChildrensData',
        'getCustomFields',
      ]),
      async userConversation() {
        const chat = await this.chat()
        chat.createDirectMessageConversation([this.user.id]).then(({ data }) => {
          this.isOpen = true
          this.conversationId = data.conversation_id
          this.selectedPanel = 'ChatConversation'
        })
      },
      init(value) {
        if (this.isInCustomerProfileOptions('Cards', 'custom-fields') || this.isInCustomerProfileOptions('Sections', 'custom-fields')) {
          this.getCustomFields(value)
        }
        if (this.isInCustomerProfileOptions('Cards', 'topics') || this.isInCustomerProfileOptions('Sections', 'topics')) {
          this.getPersonalDataTopics(value)
        }
        if (this.isInCustomerProfileOptions('Sections', 'children')) {
          this.getChildrensData(value)
        }
      },
    },
  }
</script>
